import axios from 'axios';
import {
  GET_POPULAR_BETS_REQUEST,
  GET_POPULAR_BETS_SUCCESS,
  GET_POPULAR_BETS_FAILURE,
  GET_HOMEPAGE_POPULAR_BETS_REQUEST,
  GET_HOMEPAGE_POPULAR_BETS_SUCCESS,
  GET_HOMEPAGE_POPULAR_BETS_FAILURE,
} from 'Store/constants';
import errorMessage from 'Store/actions/errorMessage';
import ProjectConfig from 'ProjectConfig';
import qs from 'query-string';
import { BULLETIN_TYPES, ALL_EVENTS, FOOTBALL, BASKETBALL, TENNIS, E_SPORTS, POPULAR_BETS_TAB_PARAMS } from 'Store/constants/sportTypes';
import { getEventScores } from 'Store/actions';

const API_GATEWAY = ProjectConfig.API_GATEWAY;
const TREND_URL = 'v3/mobile/aggregator/gamelist/events/selections/trending';
const RECOMMENDDED_URL = 'v3/mobile/aggregator/gamelist/auth/events/selections/recommended';
const POPULAR_URL = 'v3/mobile/aggregator/gamelist/events/selections/popular';


const POPULAR_BETS_REQUEST_URL_MAPPING = {
  [POPULAR_BETS_TAB_PARAMS.RECOMMENDED]: {
    [POPULAR_BETS_TAB_PARAMS.LIVE]: {
      url: RECOMMENDDED_URL,
      params: {
        bulletinType: BULLETIN_TYPES.LIVE,
        mainPage: false,
        tabType: ALL_EVENTS
      }
    },
    [POPULAR_BETS_TAB_PARAMS.PRE]: {
      url: RECOMMENDDED_URL,
      params: {
        bulletinType: BULLETIN_TYPES.PREMATCH,
        mainPage: false,
        tabType: ALL_EVENTS
      }
    }
  },
  [POPULAR_BETS_TAB_PARAMS.TRENDING]: {
    [POPULAR_BETS_TAB_PARAMS.LIVE]: {
      url: TREND_URL,
      params: {
        bulletinType: BULLETIN_TYPES.LIVE,
      }
    },
    [POPULAR_BETS_TAB_PARAMS.PRE]: {
      url: TREND_URL,
      params: {
        bulletinType: BULLETIN_TYPES.PREMATCH,
      }
    }
  },
  [POPULAR_BETS_TAB_PARAMS.POPULAR]: {
    [POPULAR_BETS_TAB_PARAMS.FOOTBALL]: {
      url: POPULAR_URL,
      params: {
        bulletinType: BULLETIN_TYPES.PREMATCH,
        tabType: FOOTBALL,
        mainPage: false,
      }
    },
    [POPULAR_BETS_TAB_PARAMS.TENNIS]: {
      url: POPULAR_URL,
      params: {
        bulletinType: BULLETIN_TYPES.PREMATCH,
        mainPage: false,
        tabType: TENNIS
      }
    },
    [POPULAR_BETS_TAB_PARAMS.BASKETBALL]: {
      url: POPULAR_URL,
      params: {
        bulletinType: BULLETIN_TYPES.PREMATCH,
        mainPage: false,
        tabType: BASKETBALL
      }
    },
    [POPULAR_BETS_TAB_PARAMS.E_SPORTS]: {
      url: POPULAR_URL,
      params: {
        bulletinType: BULLETIN_TYPES.PREMATCH,
        mainPage: false,
        tabType: E_SPORTS
      }
    },
    [POPULAR_BETS_TAB_PARAMS.ALL]: {
      url: POPULAR_URL,
      params: {
        bulletinType: BULLETIN_TYPES.PREMATCH,
        mainPage: false,
        tabType: ALL_EVENTS
      }
    }
  },
};


export const getPopularBets = (tabName, subTabName) => async dispatch => {
  try {

    dispatch({
      type: GET_POPULAR_BETS_REQUEST
    });

    const { url, params } = POPULAR_BETS_REQUEST_URL_MAPPING[tabName][subTabName];

    const queryString = qs.stringify(params, { skipNull: true, arrayFormat: 'bracket', skipEmptyString: true });

    let path = `${API_GATEWAY}/${url}?${queryString}`;

    const popularBetsRes = await axios.get(path);

    if (subTabName == POPULAR_BETS_TAB_PARAMS.LIVE && popularBetsRes.data?.data?.length > 0) {

      dispatch({
        type: GET_POPULAR_BETS_SUCCESS,
        payload: popularBetsRes.data?.data
      });

      dispatch(getEventScores(popularBetsRes.data?.data));

    }

    dispatch({
      type: GET_POPULAR_BETS_SUCCESS,
      payload: popularBetsRes.data?.data || []
    });

  } catch (e) {

    dispatch({
      type: GET_POPULAR_BETS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};


export const getHomePagePersonalOrPopularBets = (isPersonal, eventCount = 3) => async dispatch => {
  try {
    dispatch({
      type: GET_HOMEPAGE_POPULAR_BETS_REQUEST
    });

    let url = '/v3/mobile/aggregator/gamelist/events/selections/popular';
    let params = { tabType: 9999, bulletinType: 2, mainPage: true };

    if (isPersonal) {
      url =  '/v3/mobile/aggregator/gamelist/auth/events/selections/recommended';
      params = { bulletinType: 2, mainPage: true };
    }

    const res = await axios.get(url, { params });
    res?.data?.data?.splice(eventCount);

    if (!res?.data?.data?.length && isPersonal) {
      dispatch(getHomePagePersonalOrPopularBets(false, eventCount));
      return;
    }

    dispatch({
      type: GET_HOMEPAGE_POPULAR_BETS_SUCCESS,
      payload: res?.data?.data || []
    });

  } catch (e) {
    if (isPersonal) {
      dispatch(getHomePagePersonalOrPopularBets(false, eventCount));
      return;
    }
    console.log('error', e);

    dispatch({
      type: GET_HOMEPAGE_POPULAR_BETS_FAILURE,
      payload: e.response && e.response.data || errorMessage
    });
  }
};

